export default [
  {
    path: '/categories',
    name: 'categories',
    component: () => import('@/views/modules/skeleton/admin/Categories/Categories.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Categories',
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
  {

    path: '/create_category',
    name: 'create_category',
    component: () => import('@/views/modules/skeleton/admin/Categories/CreateCategory.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Categories',
          active: true,
          redirectIfLoggedIn: true,
          back: true,
        },
      ],
    },
  },
  {
    path: '/edit-category/:id',
    name: 'edit-category',
    component: () => import('@/views/modules/skeleton/admin/Categories/CreateCategory.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Edit Category',
          back: true,
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
  {
    path: '/show-category/:id',
    name: 'show_category',
    component: () => import('@/views/modules/skeleton/admin/Experiments/Experiments.vue'), // will be filtered with the category ID

    meta: {
      breadcrumb: [
        {
          text: 'Category Details',
          back: true,
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
]
